"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketsEnum = exports.EPurchasePortalModes = void 0;
var EPurchasePortalModes;
(function (EPurchasePortalModes) {
    EPurchasePortalModes["Checkout"] = "checkout";
    EPurchasePortalModes["BoxOffice"] = "box-office";
})(EPurchasePortalModes = exports.EPurchasePortalModes || (exports.EPurchasePortalModes = {}));
;
var TicketsEnum;
(function (TicketsEnum) {
    TicketsEnum["Tickets"] = "Tickets";
    TicketsEnum["AddOns"] = "Add-Ons";
})(TicketsEnum = exports.TicketsEnum || (exports.TicketsEnum = {}));
//# sourceMappingURL=EPurchasePortalModes.js.map